import { FeatureName } from '@/models/userProfile.model';

export enum AppPageNames {
  home = "Home",
  overview = "Overview",
  objections = "Objections",
  sentiment = "Sentiment",
  performance = "Performance",
  interactions = "Interactions",
  playback = "Interactions",
  playbackDetails = "Interaction",
  landing = "Landing Page",
  maintenance = "Maintenance Page",
  unknown = "Unknonwn Page",
  topics = "Topics",
  scoring = "Scoring",
  scoringScorecardDesigner = "Scoring > Create Scorecard",
  scoringScheduleDesigner = "Scoring > Create Schedule",
  promptStudio = "Prompt Studio"
}

export enum AppRoutePaths {
  home = '/',
  overview = '/overview',
  objections = '/objections',
  sentiment = '/sentiment',
  performance = '/performance',
  interactions = '/interactions',
  playback = '/playback',
  playbackDetails = '/interaction',
  landing = '/landing',
  maintenance = '/maintenance',
  pdfExport = "/pdfExport",
  topics = '/topics',
  scoring = '/scoring',
  scoringScorecardDesigner = '/scoring/scorecards/designer',
  scoringScheduleDesigner = '/scoring/schedules/designer',
  promptStudio = '/prompt-studio',
}

export enum AppRouteNames {
  home = "index",
  overview = "overview",
  objections = "objections",
  sentiment = "sentiment",
  performance = "performance",
  interactions = "interactions",
  playback = "playback",
  playbackDetails = "interaction-id",
  landing = "landing",
  maintenance = "maintenance",
  pdfExport = "pdfExport",
  topics = "topics",
  scoring = "scoring",
  scorecards = "scorecards",
  scoringScorecardDesigner = "scoring-scorecards-designer-id",
  scoringScheduleDesigner = "scoring-schedules-designer-id",
  promptStudio = "prompt-studio",
}

export const ROUTES_CONFIG = [
  {
    name: AppRouteNames.home,
    pageName: AppPageNames.home,
    pageIconCssClass: "icon-home-filled",
    featureName: FeatureName.homePage,
    isViewMode: false,
    hasTopbarFilter: false
  },
  {
    name: AppRouteNames.overview,
    pageName: AppPageNames.overview,
    pageIconCssClass: undefined,
    featureName: undefined,
    isViewMode: true,
    hasTopbarFilter: true
  },
  {
    name: AppRouteNames.objections,
    pageName: AppPageNames.objections,
    pageIconCssClass: undefined,
    featureName: FeatureName.objectionsTab,
    isViewMode: true,
    hasTopbarFilter: true
  },
  {
    name: AppRouteNames.topics,
    pageName: AppPageNames.topics,
    pageIconCssClass: undefined,
    featureName: undefined,
    isViewMode: true,
    hasTopbarFilter: true
  },
  {
    name: AppRouteNames.sentiment,
    pageName: AppPageNames.sentiment,
    pageIconCssClass: undefined,
    featureName: FeatureName.sentimentTab,
    isViewMode: true,
    hasTopbarFilter: true
  },
  {
    name: AppRouteNames.performance,
    pageName: AppPageNames.performance,
    pageIconCssClass: undefined,
    featureName: FeatureName.performanceTab,
    isViewMode: true,
    hasTopbarFilter: true
  },
  {
    name: AppRouteNames.interactions,
    pageName: AppPageNames.interactions,
    pageIconCssClass: undefined,
    featureName: undefined,
    isViewMode: true,
    hasTopbarFilter: true
  },
  {
    name: AppRouteNames.playback,
    pageName: AppPageNames.playback,
    pageIconCssClass: "icon-play-outline",
    featureName: undefined,
    isViewMode: false,
    hasTopbarFilter: true
  },
  {
    name: AppRouteNames.playbackDetails,
    pageName: AppPageNames.playbackDetails,
    pageIconCssClass: "icon-play-outline",
    featureName: undefined,
    isViewMode: false,
    hasTopbarFilter: false
  },
  {
    name: AppRouteNames.landing,
    pageName: AppPageNames.landing,
    pageIconCssClass: undefined,
    featureName: undefined,
    isViewMode: false,
    hasTopbarFilter: false
  },
  {
    name: AppRouteNames.maintenance,
    pageName: AppPageNames.maintenance,
    pageIconCssClass: undefined,
    featureName: undefined,
    isViewMode: false,
    hasTopbarFilter: false
  },
  {
    name: AppRouteNames.scoring,
    pageName: AppPageNames.scoring,
    pageIconCssClass: "icon-list-check",
    featureName: FeatureName.scoringScorecardsPage,
    isViewMode: false,
    hasTopbarFilter: false
  },
  {
    name: AppRouteNames.scoringScorecardDesigner,
    pageName: AppPageNames.scoringScorecardDesigner,
    pageIconCssClass: "icon-list-check",
    featureName: FeatureName.scoringScorecardsPage,
    isViewMode: false,
    hasTopbarFilter: false
  },
    {
    name: AppRouteNames.scoringScheduleDesigner,
    pageName: AppPageNames.scoringScheduleDesigner,
    pageIconCssClass: "icon-list-check",
    featureName: FeatureName.scoringSchedulesPage,
    isViewMode: false,
    hasTopbarFilter: false
  },
  {
    name: AppRouteNames.promptStudio,
    pageName: AppPageNames.promptStudio,
    pageIconCssClass: "icon-books-outline",
    featureName: FeatureName.promptStudioPage,
    isViewMode: false,
    hasTopbarFilter: false
  },
];